import { memo } from 'react';

import ConversionNumber from 'bloko/blocks/conversion';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import PriceCartItemHH, { PriceCartItemHHProps } from 'src/components/Price/PriceCart/PriceCartItemHH';
import translation from 'src/components/translation';
import { PriceCartProductType } from 'src/models/price/priceCart';
import { PublicationProductType } from 'src/models/price/product.types';
import { getPublicationCode, hasZpCrossPost } from 'src/utils/price/products';

import Title from 'src/components/Price/PriceCart/PriceCartProduct/Publications/Title';

const formatCount = (count: number) => <span data-qa="cart-item__count">{count}</span>;

const TrlKeys = {
    daysForPublication: {
        one: 'days.for.publication.one',
        some: 'days.for.publication.some',
        many: 'days.for.publication.many',
    },
    zpCrossPosting: 'zarplata.crossposting',
    thingOne: 'thing.one',
    thingSome: 'thing.some',
    thingMany: 'thing.many',
    allProfRoleGroup: 'billing_professional_role_group.0',
};

interface PublicationsProps {
    product: PriceCartProductType<PublicationProductType>;
}

const Publications: TranslatedComponent<PublicationsProps> = ({ trls, product }) => {
    // Код нужно взять из вложенного продукта, иначе у всех будет VPPL
    const publicationCode = getPublicationCode(product);

    const list = [
        {
            key: 'count',
            element: (
                <ConversionNumber
                    one={trls[TrlKeys.thingOne]}
                    some={trls[TrlKeys.thingSome]}
                    many={trls[TrlKeys.thingMany]}
                    value={Number(product.count)}
                    formatValue={formatCount}
                />
            ),
        },
        {
            key: 'daysForPublication',
            element: (
                <span data-qa="cart-item__period">
                    <ConversionNumber
                        one={trls[TrlKeys.daysForPublication.one]}
                        some={trls[TrlKeys.daysForPublication.some]}
                        many={trls[TrlKeys.daysForPublication.many]}
                        value={Number(product.period)}
                    />
                </span>
            ),
        },
        hasZpCrossPost(product) && {
            key: 'zpCrossposting',
            element: (
                <>
                    <p data-qa="cart-item__zp-cross-post">{trls[TrlKeys.zpCrossPosting]}</p>
                </>
            ),
        },
        {
            key: 'profRole',
            element: product.profRoleGroupTrls
                ? product.profRoleGroupTrls.map((profRoleGroupTrl, index, profRoleGroups) => (
                      <p key={profRoleGroupTrl} data-qa="cart-item__prof-role-group">
                          {profRoleGroupTrl}
                          {index !== profRoleGroups.length - 1 && ';'}
                      </p>
                  ))
                : trls[TrlKeys.allProfRoleGroup],
        },
        product.regionTrl && {
            key: 'region',
            element: <span data-qa="cart-item__region">{product.regionTrl}</span>,
        },
    ].filter(Boolean) as PriceCartItemHHProps['list'];

    return <PriceCartItemHH product={product} list={list} title={<Title publicationCode={publicationCode} />} />;
};

export default memo(translation(Publications));
